<div class="min-w-[768px]">
    <div #editor class="h-80 bg-white"></div>
</div>
